import setMaterial from "./setMaterial";

function disableMaterial(materialsArray: string[], materialSpans: NodeListOf<HTMLElement>) {
	for (const material of materialsArray) {
		setMaterial(material, materialSpans as NodeListOf<HTMLSpanElement>, true);
	}
}

export default disableMaterial;
